import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './network-offline.component.html',
  styleUrls: ['./network-offline.component.scss']
})
export class NetworkOfflineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
